<template>
    <!-- 默认的订单控制台展示界面 -->
    <div>
        <order-search
                :count-data="countTagData"
                :handle-success="handleSearch"
                :handle-re-fresh="handleInit">
            <el-col :span="1">
                <i v-show="loading" class="el-icon-loading"></i>
            </el-col>
            <el-col :span="2">
                <div>
                    <el-tag type="info" size="small">订单数量:{{ orderLength }} / {{ count }}</el-tag>
                </div>
            </el-col>

        </order-search>
        <el-row>
            <order-table @deleteOrder="deleteOrder" :show_delete="true" @handlesort="handleInit"
                         :orders="orders"></order-table>
            <next-foo
                    :no-more="noMore"
                    :handle-response="handleNext"
                    :next-url="nextUrl">
            </next-foo>
        </el-row>
    </div>

</template>

<script>
    import OrderTable from "../components/orders/OrderTable"
    import OrderSearch from "../components/orders/OrderSearch"
    import NextFoo from "../components/NextFoo"

    import {mapMutations} from 'vuex'

    export default {
        name: "OrderHome",
        data() {
            return {
                showLink: false,
                nextUrl: '',
                loading: false,
                count: 0,
                defaultUtl: `${this.$const.orderListUrl}?ordering=id`,

                // 快捷标签的配置数据
                countTagData: {
                    countTagsUrl: `${this.$const.orderListUrl}order_counts/`,
                    dataArr: [
                        {
                            count: 0,
                            tagName: '已完成: ',
                            loading: false,
                            url: `${this.$const.orderListUrl}?finish=true&ordering=id`,
                            countKey: 'finished',
                            type: 'success',
                        },
                        {
                            count: 0,
                            tagName: '未完成: ',
                            loading: false,
                            url: `${this.$const.orderListUrl}?finish=false&ordering=id`,
                            countKey: 'un_finish',
                            type: 'danger',
                        },
                        {
                            count: 0,
                            tagName: '加急: ',
                            loading: false,
                            url: `${this.$const.orderListUrl}?urgent=true&ordering=id`,
                            countKey: 'urgent',
                            type: 'danger',
                        }
                    ],
                },

            }
        },

        computed: {
            orders() {
                return this.$store.getters.home_orders['orders']
            },
            orderLength() {
                return this.orders.length
            },
            noMore() {
                return !Boolean(this.nextUrl)
            },
        },
        methods: {
            initOrders() {
                this.loading = true
                this.$getRequest(this.defaultUtl,
                ).then((response) => {
                    this.loading = false
                    this.handleInit(response)
                }).catch((error) => {
                    this.loading = false
                })
            },

            handleNext(response) {
                this.addResponse(response)
            },
            handleInit(response) {
                this.setResponse(response)
            },
            handleSearch(response) {
                this.setResponse(response)
            },

            setResponse(response) {
                const mutation = 'setHomeOrders'
                this._handleResponse(response, mutation)
            },
            addResponse(response) {
                const mutation = 'addHomeOrders'
                this._handleResponse(response, mutation)

            },
            _handleResponse(response, mutation) {
                this.count = response.data.count
                this.nextUrl = this.$utils.handleOrderUrl(response.data.next)
                this.$store.commit(mutation, response.data.results)
            },
            deleteOrder(order) {
                const url = `${this.$const.orderListUrl}${order.id}/`
                this.$deleteRequest(url)
                    .then(response => {
                        this.removeOrder(order)
                        this.$message({
                            type: "success",
                            showClose: true,
                            message: "删除成功"
                        })
                    })
            },
            ...mapMutations(['_clearHomeOrders', 'removeOrder'])
        },
        created() {
            if (this.orderLength <= 0) {
                this.initOrders()
            }
        },
        components: {
            NextFoo,
            OrderSearch,
            OrderTable
        }
    }
</script>

<style scoped>
</style>